import React, { useState } from "react";
import { FormattedMessage } from "react-intl";

import { intlShape, accessRightsShape } from "../../shapes";
import AssignableUserList from "../Users/AssignableUserList";
import {
  ActionBar,
  ActionBarButtons,
  EditActionButton,
  DeleteActionButton,
} from "../ActionBar";
import Loader from "../Loader";
import { DetailsItem } from "../Details";
import { NotFoundError } from "../../api";

import { sortBy } from "../../utils";
import { withAccessRights, withIntl } from "../../wrappers";
import {
  apiShape,
  browserShape,
  notifierShape,
  withApi,
  withBrowser,
  withNotifier,
} from "../../context";
import { Column, Container, Row } from "../Grid";
import BackButton from "../BackButton";

type Props = {
  intl: intlShape;
  match?: {
    params?: {
      id?: string;
    };
  };
  accessRights?: accessRightsShape;
  api?: apiShape;
  notifier?: notifierShape;
  browser?: browserShape;
};

export function UserGroupDetails({
  intl,
  match,
  accessRights,
  api,
  notifier,
  browser,
}: Props) {
  const [fetching, setFetching] = useState(false);
  const [usergroup, setUsergroup] = useState();
  const [users, setUsers] = useState([]);

  React.useEffect(() => {
    const loadData = async () => {
      setFetching(true);
      try {
        const [response, sortedUsers] = await Promise.all([
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          api.get(`/usergroups/${match.params.id}`, {}),
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          api.getAll(`/usergroups/${match.params.id}/users`, {
            order_by: "first_name",
            include: "technical_connect_users",
          }),
        ]);
        setUsergroup(response);
        setUsers(sortedUsers.users);
      } catch (error) {
        if (error instanceof NotFoundError) {
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          browser.navigateTo("/404");
        } else {
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          notifier.showError(api.translateError(error));
        }
      } finally {
        setFetching(false);
      }
    };
    loadData();
  }, []);

  const onConfirmDelete = async () => {
    try {
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      await api.delete(`/usergroups/${match.params.id}/`);
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      notifier.showSuccess(
        intl.formatMessage({ id: "user_group.actions.delete.notification" }),
      );
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      browser.goBack();
    } catch (error) {
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      notifier.showError(api.translateError(error));
    }
  };

  const handleOnAssignUser = async (user: $TSFixMe) => {
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    await api.post(`/usergroups/${usergroup.id}/users`, {
      users: [{ id: user.id }],
    });
    // @ts-expect-error TS(2554) FIXME: Expected 3 arguments, but got 2.
    setUsers(sortBy(users.concat([{ ...{ ...user } }]), "first_name"));
  };

  const handleOnUnassignUser = async (user: $TSFixMe) => {
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    await api.delete(`/usergroups/${usergroup.id}/users`, {
      users: [{ id: user.id }],
    });
    setUsers(users.filter((u) => (u as $TSFixMe).id !== user.id));
  };

  const usergroupElement = usergroup ? (
    <div>
      <DetailsItem
        id="user-group-name"
        translationKey="label.name"
        value={(usergroup as $TSFixMe).name}
      />
      <DetailsItem
        id="user-group-description"
        translationKey="label.description"
        value={(usergroup as $TSFixMe).description}
      />
    </div>
  ) : null;

  const usersList =
    usergroup && users && accessRights ? (
      <div id="user-list">
        <h2>
          <FormattedMessage id="users.header" />
        </h2>
        <AssignableUserList
          // @ts-expect-error TS(2322) FIXME: Type '{ users: never[]; onAssignUser: (user: any) ... Remove this comment to see the full error message
          users={users}
          onAssignUser={handleOnAssignUser}
          onUnassignUser={handleOnUnassignUser}
          canUpdate={accessRights.canUpdate}
          acceptConnectUsers
          showUserEmail
        />
      </div>
    ) : null;

  return (
    <Container>
      <Row>
        <Column>
          <BackButton />
        </Column>
      </Row>
      <Row>
        <Column>
          <ActionBar>
            <h1 id="user-group-details-header">
              <FormattedMessage id="user_group_details.header" />
            </h1>
            <ActionBarButtons>
              <EditActionButton
                id="edit-user-group-button"
                // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
                target={`/usergroups/${match.params.id}/edit`}
                // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
                disabled={!accessRights.canUpdate}
              />
              <DeleteActionButton
                id="delete-user-group-button"
                // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
                disabled={!accessRights.canDelete}
                // @ts-expect-error TS(2349) FIXME: This expression is not callable.
                modalTitle={intl.t`user_group.actions.delete.modal_title`}
                // @ts-expect-error TS(2349) FIXME: This expression is not callable.
                modalMessage={intl.t`user_group.actions.delete.modal_message`}
                onConfirm={onConfirmDelete}
              />
            </ActionBarButtons>
          </ActionBar>
        </Column>
      </Row>
      <Row>
        <Column>
          {usergroupElement}
          {usersList}
        </Column>
      </Row>
      <Loader id="user-group-details-loader" loading={fetching} />
    </Container>
  );
}

export default withIntl(
  withApi(
    // @ts-expect-error TS(2345) FIXME: Argument of type '{ (props: Readonly<Omit<WithAcce... Remove this comment to see the full error message
    withBrowser(withNotifier(withAccessRights(UserGroupDetails, "Usergroup"))),
  ),
);
